import { fetcher } from "helpers/fetcher";

import { TGetDepartmentRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getDepartment = async () => {
  return await fetcher<TGetDepartmentRes, any>(ENDPOINT.USER.GET_DEPARTMENT, {
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.GET_DEPARTMENT.version,
    },
  });
};

export const queryGetDepartment = async () => {
  return (await getDepartment()).data;
};

queryGetDepartment._key = () => [ENDPOINT.USER.GET_DEPARTMENT.url];
